<ng-container [formGroup]="formData">
  <input
    pInputText
    [type]="type ? type : 'text'"
    [maxLength]="maxLength ? maxLength : '100'"
    [id]="controlName"
    [name]="controlName"
    [placeholder]="getPlaceholder"
    [formControlName]="controlName"
    [ngClass]="{ 'mu-form-editable-mask': editableMask }"
    (click)="editableMask = false"
    (keydown)="allowOnlyNumbers ? cleanNumeric() : ''"
    (blur)="validatorService?.validateControl(formData, controlName, changeDetectorRef)"
  />
  <em class="fas fa-check-circle mu-form-input-phone" *ngIf="iconCheck"></em>
  <em class="fas fa-eye-slash mu-form-input-password" (click)="changeInputTypeAction($event, controlName)" *ngIf="changeInputType"></em>
</ng-container>
